/**
 * 图片对比组件
 * @returns
 */

import React, { useRef, useEffect } from "react";
import { Box, Flex, Icon, Image } from "@chakra-ui/react";
import { RiExpandLeftRightFill, RiExpandWidthFill } from "@remixicon/react";
import { Content } from "@/types/content";

type Props = {
  isOpen: boolean;
  image: Content;
  compareImageSrc: string;
};

const SmroomImageComparing = (props: Props) => {
  const wh = props.image.width - props.image.height;
  const rightImg = useRef<HTMLImageElement>(null);
  const rightImgBox = useRef<HTMLDivElement>(null);
  const leftImgBox = useRef<HTMLDivElement>(null);
  const leftImg = useRef<HTMLImageElement>(null);
  const moveBtn = useRef<HTMLDivElement>(null);
  const imgOuterBox = useRef<HTMLDivElement>(null);

  const handleResize = () => {
    const imgOuterBoxElement = imgOuterBox.current;
    const rightImgBoxElement = rightImgBox.current;
    if (imgOuterBoxElement && rightImgBoxElement) {
      if (
        props.image.width /imgOuterBoxElement.offsetWidth>
        props.image.height / imgOuterBoxElement.offsetHeight
      ) {
        rightImgBoxElement.style.width = `${
          imgOuterBoxElement.offsetWidth
        }px`;
        rightImgBoxElement.style.height = `${(props.image.height/props.image.width)*imgOuterBoxElement.offsetWidth}px`;
      } else {
        rightImgBoxElement.style.height = `${imgOuterBoxElement.offsetHeight}px`;
        rightImgBoxElement.style.width = `${(props.image.width/props.image.height)*imgOuterBoxElement.offsetHeight}px`;

      }
    }
  };
  useEffect(() => {
    if(props.isOpen){
      handleResize();
    }
  }, [props.isOpen]);

  useEffect(() => {
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const trackLocation = () => {
    const rightImgElement = rightImg.current;
    const leftImgBoxElement = leftImgBox.current;
    const moveBtnElement = moveBtn.current;
    document.onmousemove = (e) => {
      // 禁止选中图片
      //  window.getSelection ? window.getSelection()?.removeAllRanges() : '';
      if (window.getSelection) {
        window.getSelection()?.removeAllRanges();
      }

      if (rightImgElement && leftImgBoxElement && moveBtnElement) {
        let rect: any = rightImgElement.getBoundingClientRect();
        let position =
          ((e.pageX - rect.left) / rightImgElement.offsetWidth) * 100;
        if (position <= 0) {
          position = 0;
        }
        if (position > 100) {
          position = 100;
        }
        moveBtnElement.style.left = position + "%";
        leftImgBoxElement.style.width = position + "%";
        // if (position>=0 && position<= 100) {
        //     moveBtnElement.style.left = position + "%";
        //     leftImgBoxElement.style.width = position + "%";
        // }
      }
    };
    document.onmouseup = () => {
      document.onmousemove = null;
      document.onmouseup = null;
    };
  };

  return (
    <Box
    w="100%"
    h="100%"
    >
      <Flex
        ref={imgOuterBox}
        w="100%"
        h="100%"
        margin={"0 auto"}
        justifyContent="center"
        alignItems={"center"}
      >
        <Box ref={rightImgBox} >
          <Box
            position="relative"
            overflowX="visible"
            textAlign="center"
            w="100%"
        h="100%"
          >
            <Image
              w="100%"
              h="100%"
              ref={rightImg}
              src={props.compareImageSrc}
            />
            <Box
              ref={leftImgBox}
              width="50%"
              height="100%"
              position="absolute"
              top={0}
              left={0}
              overflowX="hidden"
              borderRight="2px solid #FFFFFF"
              boxSizing="border-box"
            >
              <Image
                ref={leftImg}
                src={props.image.image_url}
                float="left"
                height="100%"
                width="auto"
                maxWidth="none"
              />
            </Box>
            <Box
              ref={moveBtn}
              position="absolute"
              top="50%"
              left="50%"
              width="48px"
              height="48px"
              boxSizing="border-box"
              cursor="pointer"
              marginLeft="-25px"
              marginTop="-24px"
              p={0}
              color={"#FFFFFF"}
              onMouseDown={trackLocation}
              // border="2px solid #496AE1"
            >
              <RiExpandLeftRightFill size="48px" />
            </Box>
          </Box>
        </Box>
      </Flex>
    </Box>
  );
};

export default SmroomImageComparing;
